import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

/** Type to search (server side), click to pick; the picked item shows as a chip with a clear button.
 * fetchItems(q) -> [{id, label}]. value is the picked {id,label} or null. */
export default function SearchPicker({ label, placeholder, value, onChange, fetchItems, deps = [] }) {
  const { t } = useTranslation();
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const seq = useRef(0);

  useEffect(() => {
    if (!open) return undefined;
    const mine = ++seq.current;
    const timer = setTimeout(async () => {
      try {
        const found = await fetchItems(q.trim());
        if (mine === seq.current) setItems(found);
      } catch {
        if (mine === seq.current) setItems([]);
      }
    }, 250);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, open, ...deps]);

  const pick = (item) => {
    onChange(item);
    setOpen(false);
    setQ("");
  };

  return (
    <div style={{ display: "grid", gap: 4, position: "relative" }}>
      <span>{label}</span>
      {value ? (
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <strong>{value.label}</strong>
          <button type="button" aria-label={t("edgeDetail.picker.clear", { label })} onClick={() => onChange(null)}>×</button>
        </div>
      ) : (
        <input
          value={q}
          placeholder={placeholder}
          onFocus={() => setOpen(true)}
          onChange={(e) => { setQ(e.target.value); setOpen(true); }}
        />
      )}
      {open && !value && (
        <ul style={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 5, margin: 0, padding: 0, listStyle: "none", maxHeight: 220, overflowY: "auto", background: "var(--bg-card, #fff)", border: "1px solid var(--border, #ccc)" }}>
          {items.length === 0 && <li style={{ padding: 8, color: "var(--text-muted)" }}>{t("edgeDetail.picker.noResults")}</li>}
          {items.map((item) => (
            <li key={item.id}>
              <button type="button" style={{ width: "100%", textAlign: "left" }} onMouseDown={(e) => e.preventDefault()} onClick={() => pick(item)}>
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
